/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.utils

import io.kvision.panel.SimplePanel
import pl.finn.forms.tw1.DocumentTreeNode

data class FormComponent(
  var field: SimplePanel
)
